import { NavBoardDataSlice } from '../store/data-slice';

type NavBoardDraftData = {
  board: NavBoardDataSlice['board'];
  sorted: NavBoardDataSlice['sorted'];
};

export const NavBoardDraft = {
  Set: ({ sorted, board }: NavBoardDraftData, callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return localStorage.setItem('navBoard', JSON.stringify({ board, sorted }));
  },
  Get: (callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return JSON.parse(localStorage.getItem('navBoard') || 'null') as NavBoardDraftData | null;
  },
  Delete: (callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return localStorage.removeItem('navBoard');
  },
};
